module.exports = {
  ROUTE_CREATE_REQUEST: 'ROUTE_CREATE_REQUEST',
  ROUTE_CREATE_SUCCESS: 'ROUTE_CREATE_SUCCESS',
  ROUTE_CREATE_FAILURE: 'ROUTE_CREATE_FAILURE',
};
